export interface IJsonResult<T> {
  contentEncoding: IEncoding;
  contentType: unknown;
  data: T;
  jsonRequestBehavior: JsonRequestBehavior;
  maxJsonLength: number;
  recursionLimit: number;
}

export enum JsonRequestBehavior {
  AllowGet = 0,
  DenyGet = 1,
}

export interface IEncoding {
  bodyName: string;
  codePage: number;
  encodingName: string;
  headerName: string;
  webName: string;
  windowsCodePage: number;
  isBrowserDisplay: boolean;
  isBrowserSave: boolean;
  isMailNewsDisplay: boolean;
  isMailNewsSave: boolean;
  isSingleByte: boolean;
  isReadOnly: boolean;
  decoderFallback: IDecoderFallback;
  encoderFallback: IEncoderFallback;
  aSCII: IEncoding;
  latin1: IEncoding;
}

export interface IDecoderFallback {
  maxCharCount: number;
}

export interface IEncoderFallback {
  maxCharCount: number;
}
